module.exports = __webpack_public_path__ + "static/media/GIL_補助機票審核表.4eb8ed22.doc";